import { FunctionComponent } from 'react';
import { MultiValue, default as SelectInitial, SingleValue } from 'react-select';

export interface SelectOption {
  value: string;
  label: string;
}

export type SelectOnChangeParam = SingleValue<SelectOption> | MultiValue<SelectOption>;

interface SelectProps {
  isMulti?: boolean;
  options: SelectOption[];
  onChange: (option: SelectOnChangeParam) => void;
  defaultValue?: SelectOption | SelectOption[];
  selectedValue?: SelectOption | null;
  noOptionsMessage?: (obj: { inputValue: string }) => string;
  menuPlacement?: 'auto' | 'bottom' | 'top';
}

const Select: FunctionComponent<SelectProps> = ({
  isMulti = false,
  options,
  onChange,
  defaultValue,
  selectedValue,
  noOptionsMessage,
  menuPlacement = 'auto'
}) => {
  return (
    <SelectInitial
      isMulti={isMulti}
      options={options}
      onChange={onChange}
      defaultValue={defaultValue}
      name="select"
      className="DaaS-multiSelect"
      classNames={{
        control: () => '!bg-secondary-std border-0 focus-within:!shadow-none',
        input: () => '[&>input]:!border-none [&>input]:!ring-0',
        multiValue: () => '!rounded-md p-0.5',
        multiValueLabel: () => '!text-secondary-std -mb-1',
        multiValueRemove: () => '!text-secondary-std'
      }}
      menuPlacement={menuPlacement}
      value={selectedValue}
      noOptionsMessage={noOptionsMessage}
    />
  );
};

export default Select;
